<template>
  <div class="dropdown dropdown-end dropdown-right w-full">
    <label
      tabindex="0"
      class="relative cursor-pointer flex items-center justify-start h-auto rounded-xl"
      :class="{ 'w-full p-3 border border-gray-200': card }"
    >
      <user-badge
        :user-img="userImg"
        :user-name="fullName"
        :description="companyName || '&nbsp;'"
        :compact="compact"
        is-online
      />
      <button
        v-if="!compact"
        class="absolute top-1 btn btn-square btn-secondary btn-xxs opacity-0 hover:opacity-100 transition-opacity"
        :class="card ? 'right-1' : '-right-2'"
      >
        <app-icon
          name="chevron-selector-vertical"
          class="text-gray-500"
        />
      </button>
    </label>

    <div
      tabindex="0"
      class="dropdown-content w-66 ml-2 bg-gray-50 rounded-box border border-gray-200 z-1 shadow-lg"
    >
      <div class="bg-white rounded-box border-b border-gray-200 divide-y divide-gray-200">
        <list-item
          :to="profileRoutePath"
          class="text-sm"
        >
          <template #prefix>
            <app-icon
              name="user"
              class="text-gray-500"
            />
          </template>
          <span class="font-semibold">View Profile</span>
        </list-item>
        <div class="p-1">
          <p class="px-2 py-1.5 text-sm text-gray-600">You are logged in as</p>
          <div class="relative p-2 rounded-md bg-gray-50">
            <user-badge
              :user-img="userImg"
              :user-name="fullName"
              :description="companyName"
            />
          </div>
        </div>
      </div>
      <logout-button class="pb-1" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { abbreviateName } from '@/utils/string';
import UserBadge from '@/components/sidebar/UserBadge.vue';
import ListItem from '@/components/ui/list/ListItem.vue';
import LogoutButton from '@/components/auth/LogoutButton.vue';

defineProps({
  card: {
    type: Boolean,
    default: false,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  companyName: {
    type: String,
    required: true,
    default: '',
  },
  profileRoutePath: {
    type: [String, Object],
    required: true,
  },
});

const { user } = useAuth0();
const fullName = computed(() => {
  if (user.value?.given_name || user.value?.family_name) {
    return abbreviateName(user.value.given_name, user.value.family_name);
  } else {
    return user.value?.nickname;
  }
});
const userImg = computed(() => user.value?.picture);
</script>
